import axios from "axios";
import { Constants } from "../utils/Constants";

export function me() {
  return axios.get(`${Constants.url}/api/auth/me`, { _isAuthRoute: true });
}

export function refresh() {
  return axios.post(`${Constants.url}/api/auth/refresh`, null, {
    _isAuthRoute: true,
  });
}

export function redeemTransfer(transferToken) {
  return axios.post(
    `${Constants.url}/api/auth/transfer/redeem`,
    { transfer_token: transferToken },
    { _isAuthRoute: true }
  );
}

export function createTransfer(targetCtx) {
  return axios.post(
    `${Constants.url}/api/auth/transfer`,
    { target_ctx: targetCtx },
    { _isAuthRoute: true }
  );
}

export function logout() {
  return axios.post(`${Constants.url}/api/auth/logout`, null, {
    _isAuthRoute: true,
  });
}
